<template>
  <div class="SDG">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in SDGGoal" :key="index">
        <div
          class="sdg_box"
          @mouseenter="on_bot_enter"
          @mouseleave="on_bot_leave"
          @click="toSearch(item.id)"
        >
          <img
            class="banner_img"
            :src="require(`@/assets/image/Sdg/index_${item.id}.png`)"
            alt="image"
          />
          <p>{{ item.name }}</p>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev">
      <i class="iconfont icon-jiantou2"></i>
    </div>
    <div class="swiper-button-next">
      <i class="iconfont icon-jiantou"></i>
    </div>
  </div>
</template>

<script>
// 引入插件
import { mapMixin } from "@/util/mixin";
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate
} from "@/assets/js/swiper.animate1.0.3.min.js";
import "swiper/dist/css/swiper.css";
export default {
  mixins: [mapMixin],
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    Pagination
  },
  data() {
    return {
      SDGGoal: [
        {
          name: this.$t("DataServer.sdg1"),
          id: 1
        },
        {
          name: this.$t("DataServer.sdg2"),
          id: 2
        },
        {
          name: this.$t("DataServer.sdg3"),
          id: 3
        },
        {
          name: this.$t("DataServer.sdg4"),
          id: 4
        },
        {
          name: this.$t("DataServer.sdg5"),
          id: 5
        },
        {
          name: this.$t("DataServer.sdg6"),
          id: 6
        },
        {
          name: this.$t("DataServer.sdg7"),
          id: 7
        },
        {
          name: this.$t("DataServer.sdg8"),
          id: 8
        },
        {
          name: this.$t("DataServer.sdg9"),
          id: 9
        },
        {
          name: this.$t("DataServer.sdg10"),
          id: 10
        },
        {
          name: this.$t("DataServer.sdg11"),
          id: 11
        },
        {
          name: this.$t("DataServer.sdg12"),
          id: 12
        },
        {
          name: this.$t("DataServer.sdg13"),
          id: 13
        },
        {
          name: this.$t("DataServer.sdg14"),
          id: 14
        },
        {
          name: this.$t("DataServer.sdg15"),
          id: 15
        },
        {
          name: this.$t("DataServer.sdg16"),
          id: 16
        },
        {
          name: this.$t("DataServer.sdg17"),
          id: 17
        }
      ],
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 20,
        loop: true,
        // autoplay: {
        //   //自动轮播
        //   delay: 1500,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function() {},
          slideChangeTransitionEnd: function() {},
          slideChange: function() {
            swiperAnimate(this);
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    toSearch(id) {
      this.$router.push(`/dataSearch?goals=${id}`);
    },
    on_bot_enter() {
      //鼠标放上暂停轮播
      this.swiper.autoplay.stop();
    },
    on_bot_leave() {
      this.swiper.autoplay.start();
    }
  },
  mounted() {}
};
</script>

<style lang="scss" >
@media screen and (min-width: 1026px) {
  .SDG {
    width: 100%;
    padding: 0 34px;
    margin: 20px auto;
    position: relative;
    overflow: hidden;
    height: 100px;
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev:hover i {
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
      background: #eeeded;
    }
    .swiper-button-next:hover i {
      background: #eeeded;
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
    }
    .swiper-button-prev {
      left: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-next {
      right: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      &:hover .banner_img {
        transition: 0.2s;
        transform: scale(1.2);
      }
      &:hover {
        transition: 0.2s;
        background: rgba(159, 226, 245, 0.1);
      }
      &:hover p {
        transition: 0.2s;
        font-weight: 600;
        color: rgb(40, 89, 250);
      }

      cursor: pointer;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .banner_img {
        transition: 0.2s;
        object-fit: cover;
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }
      p {
        margin-top: 8px;
        transition: 0.2s;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1025px) {
  .SDG {
    width: 100%;
    padding: 0 34px;
    margin: 20px auto;
    position: relative;
    overflow: hidden;
    height: 100px;
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev:hover i {
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
      background: #eeeded;
    }
    .swiper-button-next:hover i {
      background: #eeeded;
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
    }
    .swiper-button-prev {
      left: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-next {
      right: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      &:hover .banner_img {
        transition: 0.2s;
        transform: scale(1.2);
      }
      &:hover {
        transition: 0.2s;
        background: rgba(159, 226, 245, 0.1);
      }
      &:hover p {
        transition: 0.2s;
        font-weight: 600;
        color: rgb(40, 89, 250);
      }

      cursor: pointer;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .banner_img {
        transition: 0.2s;
        object-fit: cover;
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }
      p {
        margin-top: 8px;
        transition: 0.2s;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>